export const iconFontAwesomeSecurityTowerObservation = (
	<i className="fa-solid fa-tower-observation"></i>
);
